<div style="padding: 1em 5%;">

	<div class="aPage">

		<div style="text-align: center; margin: 0 0 3em 0;">
			<a [routerLink]="['/auth/login']" title="Startseite">
				<img
					style="width: 20em; max-width: 100%; mix-blend-mode: darken;"
					[src]="logoSrc || 'assets/logo.png'"
				>
			</a>
		</div>

		<router-outlet></router-outlet>

	</div>

	<footer-login></footer-login>

</div>

